import { createUseStyles } from "react-jss";
import { fonts } from "../../../core";

const useStyles = createUseStyles((theme) => ({
  container: {
    direction: "rtl",
    position: "relative",
  },
  text: ({ text }) => {
    return {
      whiteSpace: "pre-line",
      direction: /^[a-zA-Z]/i.test(text) ? "ltr" : "rtl",
      fontSize: theme.messageFontSize,
    };
  },
  image: {
    minHeight: 60,
    float: "left",
    position: "relative",
    backgroundSize: "cover!important",
    backgroundPosition: "center center!important",
    backgroundRepeat: "no-repeat!important",
  },
  buttons: {
    paddingTop: 16,
  },
  button: {
    borderRight: "4px solid #FFC067",
    marginBottom: 8,
    "& *": {
      fontSize: `calc( ${theme.messageFontSize} - 3px)!important`,
    },
    textAlign: "right",
    fontSize: `calc( ${theme.messageFontSize} - 3px)!important`,
    display: "block!important",
    padding: `4px 7px!important`,
    backgroundColor: `${theme.answerBtnBg}!important`,
    "&:hover": {
      backgroundColor: `${theme.answerBtnBgHover}!important`,
      boxShadow: `0 1px 2px 0 ${theme.bubbleShadowColor}`,
    },
    color: `${theme.answerBtnColor}!important`,
  },
  modalImage: {
    height: "calc(100vh - 40px)",
  },
  backdropClassName: {
    opacity: "0.7!important",
  },

  closeIcon: {
    position: "fixed",
    top: 10,
    right: 10,
    cursor: "pointer",
  },
  modalBody: {
    backgroundSize: "contain!important",
    backgroundPosition: "center center!important",
    backgroundRepeat: "no-repeat!important",
  },

  imageslist: {
    width: "80%",
  },
  imagebox: {
    minWidth: 100,
  },
  imagesBox: {
    margin: [20, 0, 0],
    display: "flex",
    flexWrap: "wrap",
    width: "300px",
    borderRadius: 5,
    "& img": {
      width: "50%",
    },
  },
  imageBox: {
    borderRadius: 5,
    cursor: "pointer",
    width: "50%",
    position: "relative",
    "&:after": {
      content: '""',
      float: "left",
      paddingTop: "100%",
    },
  },
  singleImagesBox: {
    display: "flex",
    flexWrap: "wrap",
    borderRadius: 5,
    "& img": {
      width: "100%",
    },
  },
  singleImageBox: {
    borderRadius: 5,
    cursor: "pointer",
    width: "100%",
    position: "relative",
    "&:after": {
      content: '""',
      float: "left",
      paddingTop: "100%",
    },
  },
  "@media screen and (max-width: 399px) ": {
    imagesBox: {
      width: "100%",
    },
  },
  "@media screen and (min-width:400px) and (max-width: 687px)": {
    imagesBox: {
      width: "220px",
    },
  },
}));
export { useStyles };
